//@ts-nocheck
import React from "react";
import { useState, useEffect } from "react";
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem, IconButton } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { FaSortUp, FaSortDown } from "react-icons/fa"; // Importing FontAwesome icons
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import { getSignedAgreement } from "../../redux/slice/signedagreementSlice";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from "@mui/icons-material/Download";
import { jsPDF } from "jspdf";
import CircularProgress from '@mui/material/CircularProgress';
import CommonHeading from "../../components/commonComponents/commonHeading";
import { getAPIMKey, getInvestorApiUrl } from "../../utils/config";
import { RootState } from "@/redux/store";
export default function LegalDocuments() {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortBy, setSortBy] = useState("name"); // default sorting by name
  const [sortDirection, setSortDirection] = useState("asc"); // default sorting order is ascending
  const [base64String, setBase64String] = useState();
  const [pdfUrl, setPdfUrl] = useState("");
  const dispatch = useDispatch();
  const { instance } = useMsal();
  const [loading, setLoading] = useState(false);
  const loginUserDetails = useSelector((store: RootState) => store.user.loginUserDetails)
  const email = sessionStorage.getItem("isImpersonate") === "true" ? loginUserDetails?.Email : instance.getActiveAccount()?.idTokenClaims?.email;
  const { item } = useSelector((state) => state.signedAgreement);

  const documents = [
    {
      name: "Terms of Use",
      status: "Completed",
      link: "https://www.xome.com/pages/terms-of-use",
    },
    {
      name: "Auction Participation Agreement",
      status: "Completed",
      link: "https://www.xome.com/auctions/legaldisclosures/eventagreement",
    },
    {
      name: "Receiving Calls & Text - TCPA",
      status: "Completed",
      link: "https://www.xome.com/auctions/legaldisclosures/tcpa",
    },
    {
      name: "Real Estate Investing Disclaimer",
      status: "Completed",
      link: "https://www.xome.com/pages/investing-disclaimer",
    },
    {
      name: "Privacy Policy",
      status: "Completed",
      link: "https://www.xome.com/pages/privacy-policy",
    },
    {
      name: "eSign Consent Disclosure",
      status: "Completed",
      link: "https://www.xome.com/auctions/legaldisclosures/esignature",
    },
    {
      name: "Accessibility Statement",
      status: "Completed",
      link: "https://www.xome.com/pages/accessibility-statement",
    },
    {
      name: "Bidding Agreement",
      status: "Completed",
      link: `${pdfUrl}`,
      clickable: true
    },
    {
      name: "Passport Account Agreement",
      status: "Completed",
      link: `${getInvestorApiUrl()}/PassportAccountAgreement?subscription-key=${getAPIMKey()}`,
      clickable: false
    },
  ];

  const fetchSignedAgreement = async () => {
    try {
      console.log(email)
      const agreement = await dispatch(getSignedAgreement(email)).unwrap();
      console.log("aggrement", agreement)      // After fetching the agreement, convert the image to Base64
      if (agreement.data) {
        setBase64String(agreement.data);
      }
    } catch (error) {
      console.log("Error fetching agreement:", error);
    }
  };
  useEffect(() => {
    fetchSignedAgreement();
  }, [email]);
  console.log("test case", base64String)
  useEffect(() => {
    if (base64String) {
      // const byteCharacters = atob(base64String); 
      setPdfUrl(base64String);

      // Clean up the URL when the component is unmounted
      // return () => URL.revokeObjectURL(url);
    }
  }, [base64String]);

  const handleSort = (column: any) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };
  const [pdfopen, setPdfOpen] = useState(false)
  // Sorting logic
  const sortedDocuments = [...documents].sort((a, b) => {
    if (sortBy === "name") {
      return sortDirection === "asc"
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name);
    } else if (sortBy === "status") {
      return sortDirection === "asc"
        ? a.status.localeCompare(b.status)
        : b.status.localeCompare(a.status);
    }
    return 0;
  });

  const handleDownload = () => {
    // Initialize jsPDF instance
    const doc = new jsPDF();
    const marginLeft = 10;
    const marginTop = 10;
    const pageWidth = doc.internal.pageSize.width;
    setLoading(true);
    // Ensure HTML content renders correctly within the PDF
    doc.html(document.getElementById('pdf-content')!, {
      callback: function (doc) {
        doc.save('Bidding_Agreement.pdf');
        setLoading(false);  // Save the PDF with the specified name
      },
      x: 0,
      y: 5,
      html2canvas: {
        scale: 0.19,
      },

    });
  };

  const paginatedDocuments = sortedDocuments.slice(0, rowsPerPage);

  return (
    <>
      <Dialog
        open={pdfopen}
        onClose={() => setPdfOpen(false)}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg" // Adjust max width of the dialog
        sx={{ zIndex: 999999999 }}
        PaperProps={{
          style: {
            width: '80vw', // Use 80% of viewport width
            height: '100vh', // Use 80% of viewport height
            maxHeight: '90vh', // Limit the height to 90% of the viewport

          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" sx={{ fontSize: "13px", display: "flex", justifyContent: "space-between" }}>
          <Typography>Bidding Agreement</Typography>
          <Typography sx={{ textAlign: "right" }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* Download button */}
              {/* Loader (will be shown when loading state is true) */}
              {loading && (
                <CircularProgress size={24} sx={{ color: "#FF5C39" }} />
              )}

              {!loading && (<IconButton
                edge="end"
                color="inherit"
                onClick={handleDownload}
                aria-label="download"
                sx={{ padding: 0, fontSize: "12px", marginRight: 1 }}
              >
                <DownloadIcon />
              </IconButton>)}

              {/* Close button */}
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => setPdfOpen(false)}
                aria-label="close"
                sx={{ padding: 0, fontSize: "12px" }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <div
            id="pdf-content"
            style={{
              whiteSpace: "pre-wrap", // Ensure newlines are handled correctly
              wordWrap: "break-word", // Prevent overflow
              padding: "10px", // Add padding for better spacing
              overflowY: 'auto', // Enable scrolling if content overflows
            }}
            dangerouslySetInnerHTML={{ __html: pdfUrl }}
          />

        </DialogContent>
      </Dialog>
      <Helmet>
        <title>{`xBid | Disclosures / Documents`}</title>
        <meta name="description" content={`Disclouser documents`} />
      </Helmet>
      <CommonHeading sx={{ mb: 2, fontWeight: "600", fontSize: 22, mt: { sm: "20px", md: "0px", xs: "2px" } }} heading={"Legal Disclosures / Documents"} />

      <Box
        sx={{
          width: { md: "95%" },
          backgroundColor: "#FFFFFF",
          padding: 2,
          marginTop: 2,
        }}
      >
        <div className="flex justify-end items-center gap-2 pr-5">
          <h6 className="text-[#838383] text-[15px] font-medium leading-[24px]">
            Rows per page
          </h6>
          <Select
            value={rowsPerPage}
            onChange={(e) => setRowsPerPage(Number(e.target.value))}
            size="small"
            sx={{
              borderRadius: "12px",
              borderColor: "#D9D9D9",
              color: "#838383",
              px: 1,
            }}
            IconComponent={ExpandMore}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </div>
        <TableContainer
          sx={{
            paddingTop: "10px",
          }}
        >
          <Table>
            <TableHead>
              <TableRow className="border ">
                <TableCell className="text-base font-medium leading-[24px] text-[#464A53]">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("name")}
                  >
                    Name of Document
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "4px",
                        position: "relative"
                      }}
                    >
                      <ArrowDropUpRoundedIcon
                        fontSize="large"
                        sx={{
                          color: sortDirection === "asc" ? "black" : "grey",
                          position: "absolute",
                          top: "-21px",
                          marginBottom: 0, // Remove bottom margin to eliminate gap between icons
                        }}
                      />
                      <ArrowDropDownRoundedIcon
                        fontSize="large"
                        sx={{
                          color: sortDirection === "desc" ? "black" : "grey",
                          position: "absolute",
                          bottom: "-22px",
                          marginTop: 0, // Remove top margin
                        }}
                      />
                    </div>
                  </div>
                </TableCell>
                <TableCell
                  align="right"
                  className="text-base font-medium leading-[24px] text-[#464A53]"
                  style={{ paddingRight: "55px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      justifyContent: "flex-end",
                    }}
                    onClick={() => handleSort("status")}
                  >
                    Status
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "4px",
                        position: "relative"
                      }}
                    >
                      <ArrowDropUpRoundedIcon
                        fontSize="large"
                        sx={{
                          color: sortDirection === "asc" ? "black" : "grey",
                          position: "absolute",
                          top: "-21px",
                          marginBottom: 0, // Remove bottom margin to eliminate gap between icons
                        }}
                      />
                      <ArrowDropDownRoundedIcon
                        fontSize="large"
                        sx={{
                          color: sortDirection === "desc" ? "black" : "grey",
                          position: "absolute",
                          bottom: "-22px",
                          marginTop: 0, // Remove top margin
                        }}
                      />
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedDocuments.map((doc) => (
                <TableRow key={doc.name}>
                  <TableCell
                    sx={{
                      color: "#FF5C39",
                      textDecoration: "underline",
                      cursor: doc.link ? "pointer" : "default",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 500,
                    }}
                  >
                    {doc.link && !doc.clickable ? (
                      <a
                        href={doc.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc.name}
                      </a>
                    ) : doc?.clickable ? (
                      <a
                        onClick={() => { setPdfOpen(true) }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {doc.name}
                      </a>
                    ) : (
                      doc.name
                    )}
                  </TableCell>
                  <TableCell
                    sx={{
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 500,
                    }}
                    align="right"
                  >
                    {doc.status}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
}
